import { LogLevel, type Configuration } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_WEB_CLIENT_ID;

if (!tenantId || !clientId) {
  throw new Error('VITE_ENTRA_TENANT_ID and VITE_ENTRA_WEB_CLIENT_ID must be set');
}

/** Single-tenant authority: accounts from any other tenant cannot sign in. */
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    knownAuthorities: ['login.microsoftonline.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

export const apiScopes = [import.meta.env.VITE_API_SCOPE];
